import {useQueries} from "@tanstack/react-query";
import approvalActionsService from "../../../../services/reports/approval-actions-service.js";

const UseFetchOptions = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['creators'],
                queryFn: () => approvalActionsService.creators(),
                initialData: []
            },
            {
                queryKey: ['evaluators'],
                queryFn: () => approvalActionsService.evaluators(),
                initialData: []
            }
        ]
    });

    return {
        creatorsOptions: queries[0].data,
        evaluatorsOptions: queries[1].data
    }
}

export default UseFetchOptions;